import React from 'react';
import { Grid, useMediaQuery } from '@mui/material';
import {
	InstantDealDisplayCard,
	InstantProspectDisplayCard,
} from '@/components/cards/DashboardDisplayCards/InstantDealDisplayCard';
import { TasksDueCard } from '@/components/cards/DashboardDisplayCards/TasksDueCard';

const HomepageDashboard = () => {
	const isAbove735 = useMediaQuery('(min-width:736px)');
	const isAbove1150 = useMediaQuery('(min-width:1150px)');

	const sizeProps = {
		size: {
			xs: isAbove735 ? 4 : 12,
			md: isAbove1150 ? 2 : 4,
		},
	};

	return (
		<Grid container spacing={2} justifyContent={'center'}>
			<Grid {...sizeProps}>
				<InstantProspectDisplayCard title={'Prospects'} />
			</Grid>
			<Grid {...sizeProps}>
				<InstantDealDisplayCard
					title='New Business Leads'
					pipelineId={process.env.REACT_APP_PIPELINE_NEW_BUSINESS}
				/>
			</Grid>
			<Grid {...sizeProps}>
				<InstantDealDisplayCard
					title='Renewals'
					pipelineId={process.env.REACT_APP_PIPELINE_RENEWALS}
				/>
			</Grid>
			<Grid {...sizeProps}>
				<InstantDealDisplayCard
					title='Endorsements'
					pipelineId={process.env.REACT_APP_PIPELINE_ENDORSEMENTS}
				/>
			</Grid>
			<Grid {...sizeProps}>
				<InstantDealDisplayCard
					title='Claims'
					pipelineId={process.env.REACT_APP_PIPELINE_CLAIMS}
				/>
			</Grid>
			<Grid {...sizeProps}>
				<TasksDueCard />
			</Grid>
		</Grid>
	);
};

export default HomepageDashboard;
